import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_4: FaireProductEntity = {
  token: "beverage-4",
  type: "product",
  name: "Herbal Tea Infusion",
  brandName: "Tea Leaf Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/142551a0d6d9e44fd24a58838915073cb81081076b529cd4eff018f5dbb48f4a.webp",
  priceDollars: 14,
  msrpDollars: 22,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
